import { Box, Typography, useTheme } from '@mui/material';

export interface InfoCalloutProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
  dashed?: boolean;
}

const InfoCallout: React.FC<InfoCalloutProps> = ({ icon, title, description, action, dashed = false }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        border: `1px ${dashed ? 'dashed' : 'solid'}`,
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: theme.palette.blueGrey[50],
        p: 2.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        {icon}
        <Box>
          <Typography variant='s' sx={{
            fontWeight: 500
          }}>{title}</Typography>
          <Typography variant='body2' sx={{
            color: 'text.secondary'
          }}>{description}</Typography>
        </Box>
      </Box>
      {action}
    </Box>
  );
};

export default InfoCallout;
